export const convertClusterParams = (params: Record<string, any>) => {
  const newParams = { ...params };
  if (newParams?.clusters) {
    newParams.clusterIds = newParams.clusters;
    delete newParams.clusters;
  }
  return newParams;
};
